

import { forwardRef, useState, useEffect } from "react"
import styles from './index.module.scss'
import { BATCH_IMAGES_TYPE } from '@utils/CONST';
import Utils from '@utils/utils';
import Iconfont from '@utils/Iconfont';
import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';


const list = [{
    value: BATCH_IMAGES_TYPE.TRYON_BATCH,
    item: [
        { img: 'sample1.png', label: '单件、无遮挡、清晰' },
        { img: 'sample2.png', label: '请勿上传上身图', error: true },
        { img: 'sample3.png', label: '请勿上传多件服装图', error: true },
        { img: 'sample4.png', label: '请勿上传模糊图片', error: true },
    ]
}, {
    value: BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH,
    item: [
        { img: 'sample_1.png', label: '图片清晰，无遮挡' },
        { img: 'sample_2.png', label: '光线过暗', error: true },
        { img: 'sample_3.png', label: '模特被遮挡', error: true },
        { img: 'sample_4.png', label: '模特模糊', error: true },
    ]
}, {
    value: BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH,
    item: [
        { img: 'sample_1.png', label: '图片清晰，无遮挡' },
        { img: 'sample_2.png', label: '光线过暗', error: true },
        { img: 'sample_3.png', label: '模特被遮挡', error: true },
        { img: 'sample_4.png', label: '模特模糊', error: true },
    ]
}, {
    value: BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH,
    item: [
        { img: 'sample101.png', label: '单件、无遮挡、清晰' },
        { img: 'sample102.png', label: '模特光线过暗', error: true },
        { img: 'sample103.png', label: '模特主体模糊', error: true },
    ]
}, {
    value: BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH,
    item: [
        { img: 'sample104.png', label: '商品清晰，PNG格式透明背景' },
        { img: 'sample105.png', label: '主、辅品相对大小与实际一致' },
        { img: 'sample106.png', label: '商品有遮挡', error: true },
        { img: 'sample107.png', label: '单图含多件商品', error: true },
    ]
}, {
    value: BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH,
    item: [
        { img: 'sample_1.png', label: '图片清晰，无遮挡' },
        { img: 'sample_2.png', label: '光线过暗', error: true },
        { img: 'sample_3.png', label: '模特被遮挡', error: true },
        { img: 'sample_4.png', label: '模特模糊', error: true },
    ]
}, {
    value: BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH,
    item: [
        { img: 'sample_1.png', label: '图片清晰，无遮挡' },
        { img: 'sample_2.png', label: '光线过暗', error: true },
        { img: 'sample_3.png', label: '模特被遮挡', error: true },
        { img: 'sample_4.png', label: '模特模糊', error: true },
    ]
}, {
    value: BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH,
    item: [
        { img: 'sample110.jpg', label: '水印' },
        { img: 'sample111.jpg', label: '营销文字' },
        { img: 'sample112.jpg', label: '电商贴片' },
        { img: 'sample113.jpg', label: '介绍贴片' },
        { img: 'sample114.jpg', label: '设计贴片' },
    ]
}, {
    value: BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH,
    item: [
        { img: 'sample115.png' },
        { img: 'sample116.png' },
        { img: 'sample117.png' },
        { img: 'sample118.png' },
        { img: 'sample119.png' },
    ]
}, {
    value: BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH,
    item: [
        { img: 'sample_1.png', label: '图片清晰，无遮挡' },
        { img: 'sample_2.png', label: '光线过暗', error: true },
        { img: 'sample_3.png', label: '模特被遮挡', error: true },
        { img: 'sample_4.png', label: '模特模糊', error: true },
    ]
}, {
    value: BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH,
    item: [
        { img: 'sample_5.png', label: '图片清晰，无遮挡' },
        { img: 'sample_8.png', label: '图片不清晰', error: true },
    ]
}]

const ServiceSampleModal = forwardRef((props, ref) => {
    const [showList, setShowList] = useState([])

    useEffect(() => {
        if (!props.showValue) return
        const selectedItem = list.find(item => item.value === props.showValue)?.item;
        setShowList(selectedItem)
    }, [props.showValue])

    let width = 48
    const selectedItem = list.find(item => item.value === props.showValue)?.item;
    for (let item of selectedItem) {
        width += 160
    }
    width += 48 * (selectedItem.length - 1)

    return (
        <>
            <div
                className={styles.ServiceSampleStyl}
                style={{ width: width }}
            >
                {
                    showList.map(item => (
                        <div key={item.img} className={`${styles.sampleItemStyl} ${item.colspan && styles[`colspan${item.colspan}`]}`}>
                            <img src={Utils.getImgThumbnail(`https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/servicepage/${item.img}`)} alt="" />
                                                        <p style={{ color: item.error ? '#FF0000' : '#262626' }}>
                                {item.label && (item.error
                                    ? <CloseCircleFilled style={{ color: '#FF1B0E', fontSize: 14, marginRight: 8 }} />
                                    : <CheckCircleFilled style={{ color: '#34C759', fontSize: 14, marginRight: 8 }} />)}
                                {item.label}
                            </p>
                        </div>
                    ))
                }
            </div>
            {props.showValue == BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH &&
                <p ><Iconfont style={{ marginRight: 8, color: '#34C759' }} type="icon-general_correct" />单件、无遮挡、清晰</p>}
        </>

    )
})

export default ServiceSampleModal